import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { PrivateAxios } from "../../api";

export const toggleFavorite = createAsyncThunk("favouriteSlice/toggleFavorite",
  async ({ eco_products_id, status }, { rejectWithValue }) => {
    try {
      const response = await PrivateAxios.post("/api/ecomerce/product/favoraite", {
        eco_products_id: eco_products_id,
        status: status
      },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (!response.data.status) {
        return rejectWithValue(response.data.message || "Invalid status.");
      }
      console.log(response.data.data)
      return response.data.data;

    } catch (error) {
      console.error("Error toggle favorite:", error.message);
      return rejectWithValue(
        error.response?.data || error.request || "Failed to toggle favorite"
      );
    }
  })

  export const getFavorites = createAsyncThunk(
  "favoriteSlice/getFavorites",
  async (_, { rejectWithValue }) => {
    try {
      const response = await PrivateAxios.get(
        "/api/ecomerce/product/favoraite/list"
      );

      if (!response.data.status) {
        return rejectWithValue(response.data.message || "Invalid status.");
      }

      return response.data.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to fetch favorites"
      );
    }
  }
);

const initialState = {
  favorites: [],
  status: "idle",
  error: null,
}
let favoriteSlice = createSlice({
  name: "favoriteSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(toggleFavorite.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(toggleFavorite.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.favorites = action.payload
      })
      .addCase(toggleFavorite.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })

      // Get Favorites
    .addCase(getFavorites.pending, (state) => {
      state.status = "loading";
    })
    .addCase(getFavorites.fulfilled, (state, action) => {
      state.status = "succeeded";
      state.favorites = action.payload;
    })
    .addCase(getFavorites.rejected, (state, action) => {
      state.status = "failed";
      state.error = action.payload;
    });
  }

})


export default favoriteSlice.reducer












